import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import withValidator from '../../../models/form/withValidator';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    content: {
      rules: [
        {
          feedback: 'Content is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
  },
};

class NoteForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: { content: '' },
      errorFeedback: {},
      isFormDisabled: true,
      content: !this.props.initialValues ? '' : this.props.initialValues.content,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        content: this.state.content,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
    if (nextProps.initialValues && !Object.is(this.props.initialValues, nextProps.initialValues)) {
      this.setState({ content: nextProps.initialValues.content });
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.setState({ [name]: value }, () =>
      this.props.validateField(name, value, true));
  }

  handleSubmit(event) {
    event.preventDefault();
    const reportGuid = this.props.addingNoteFor;
    const properties = {
      content: this.state.content,
      reportGuid,
    };
    this.props.onSave(properties);
  }

  render() {
    return (
      <Fragment>
        <Form
          className="m-3"
          noValidate
          onSubmit={event => this.handleSubmit(event)}
        >
          <FormGroup>
            <Label for="title">
              Content <i className="fa fa-asterisk" />
            </Label>
            <Input
              className={this.state.cssValidationClasses.content}
              id="content"
              name="content"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="Enter Note"
              type="textarea"
              rows={10}
              value={this.state.content}
            />
            <FormFeedback>{this.state.errorFeedback.content}</FormFeedback>
          </FormGroup>
          <div style={{ textAlign: 'right' }}>
            <button
              className="button primary"
              disabled={this.state.isFormDisabled}
            >
              Submit
            </button>
          </div>
        </Form>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    addingNoteFor: state.notes.addingNoteFor,
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps)(withValidator(NoteForm, validatorConfig));
